import { t } from 'i18next';

export enum KeyType {
  RSA = 'RSA',
  DSA = 'DSA',
  EC = 'EC',
  DH = 'DH',
  PASSWORD_BASED = 'PASSWORD_BASED',
  SYMMETRIC = 'SYMMETRIC',
  FALCON = 'FALCON',
  DILITHIUM = 'DILITHIUM',
  SPHINCS = 'SPHINCS',
}

export const getKeyTypeLabel = (type: KeyType): string => {
  return t(`keyProperties.types.${type}`);
};
